import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';
import Company from '@/models/Company';
import Driver from '@/models/Driver';

export default class DriverRepository extends EntityBaseRepository {
    public list(payload: { company: Company, from: string, to: string, withDeleted: boolean }): Promise<AxiosResponse> {
        return this.axiosClient.get(`driver?company=${payload.company.id}&from=${payload.from}&to=${payload.to}&withDeleted=${payload.withDeleted}`);
    }

    public get(payload: { id: string }): Promise<AxiosResponse> {
        return this.axiosClient.get(`driver/${payload.id}`);
    }

    public getDeleted(): Promise<AxiosResponse> {
        return this.axiosClient.get('driver/deleted');
    }

    public create(payload: { driver: Driver, company: Company }): Promise<AxiosResponse> {
        return this.axiosClient.post(
            `driver/createDriverForCompany?company=${payload.company.id}`, payload.driver.parseToObject());
    }

    public update(payload: { driver: Driver }): Promise<AxiosResponse> {
        return this.axiosClient.patch(`driver/${payload.driver.id}`, payload.driver.parseToObject());
    }

    public delete(payload: { id: string }): Promise<AxiosResponse> {
        return this.axiosClient.delete(`driver/${payload.id}`);
    }

    public recycle(payload: {id: string}): Promise<AxiosResponse> {
        return this.axiosClient.get(`driver/${payload.id}/recycle`);
    }

    /** Cross-company list of blocked drivers for the moderation view. */
    public listBlocked(): Promise<AxiosResponse> {
        return this.axiosClient.get('driver/blocked');
    }

    public block(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`driver/${payload.id}/block`, { reason: payload.reason });
    }

    public unblock(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`driver/${payload.id}/unblock`, { reason: payload.reason });
    }

    /**
     * The query is a path segment, not a query parameter, so it has to be
     * encoded: a typed `/` would otherwise split the route and `?` or `#`
     * would truncate it. This matters now that the search fires while the
     * user types and sees every half-finished string.
     */
    public searchDriver(query: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`driver/search/${encodeURIComponent(query)}`);
    }
}
